import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { UnpackResponse } from "../../../api/src/lib";
import type { InsightsController } from "../../../api/src/insights/insights.controller";
import { useAuthenticatedFetch } from "../lib/api";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";

const RebalanceOpportunities = () => {
  const {
    isPending: isPendingAccountOpportunities,
    data: dataAccountOpportunities,
  } = useAuthenticatedFetch<
    UnpackResponse<InsightsController["accountOpportunities"]>
  >("/insights/account-opportunities");
  const accountOpportunities = dataAccountOpportunities?.data;

  return isPendingAccountOpportunities ? (
    <ListGroupItem>
      <Loading />
    </ListGroupItem>
  ) : !accountOpportunities ? (
    <InsightFailed />
  ) : (
    <ListGroupItem>
      {accountOpportunities.accountsWithExcessCash.length <= 0 ? (
        "0 Accounts"
      ) : (
        <Link to="/clients/accounts?insight=accounts-excess-cash">
          {accountOpportunities.accountsWithExcessCash.length} Accounts
        </Link>
      )}{" "}
      have excess cash.
    </ListGroupItem>
  );
};

export default RebalanceOpportunities;
